import {
    StyleSheet
} from "react-native";
import type {
    PaginationStatusDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        flexShrink: 0
    },
    text: {
        fontVariant: [
            "tabular-nums"
        ]
    }
});

export const useStyles = ({
    spaces
}: PaginationStatusDynamicStyleType) => {
    return {
        container: {
            paddingHorizontal: spaces.spacingSm
        }
    };
};
export default stylesheet;
